import { render, staticRenderFns } from "./SubscriptionsAdminView.vue?vue&type=template&id=31684cdf&scoped=true&"
import script from "./SubscriptionsAdminView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsAdminView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsAdminView.vue?vue&type=style&index=0&id=31684cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31684cdf",
  null
  
)

export default component.exports